module.exports = __webpack_public_path__ + "img/ii5-towards-a-just-transition.14bd1ff5.png";